import { useState, useEffect } from 'react';
import { Title } from '../../../component/title/Title';
import Modal from '../../../component/modal/Modal.component';
import GridComponent from '../../../component/grid/GridComponent.component';
import {
  deleteFunctionality,
  getFunctionality,
  putFunctionality,
  postFunctionality,
} from './Functionality.service';
import Form from './form/Form.component';
import Table from '../../../component/table/Table.component';
import {
  ACTION_DELETE,
  ACTION,
  Action,
  ACTION_EDIT_SUBMIT,
  ACTION_VIEW,
} from '../../../component/table/interfaces/TableInterface';
import ModalDelete from '../../../component/modal/ModalDelete.component';
import { useSnackbar } from '../../../context/Snackbar';
import Functionality from './interfaces/Functionality';
import { Pagination } from '../../../component/table/interfaces/Pagination';
import { INITIAL_PAGINATION } from '../../../component/table/component/pagination/utils/Pagination';
import useModal from '../../../hooks/useModal';
import { useHistory } from 'react-router-dom';
import ButtonFormFull from '../../../component/buttton/ButtonFormFull.component';

export default function FunctionalityComponent() {
  let history = useHistory();
  const [open, addModal] = useModal();
  const { setSnackbar } = useSnackbar();
  const [functionality, setFunctionality] = useState<Functionality[]>([]);
  const [request, setRequest] = useState<boolean>(true);
  //   const [total, setTotal] = useState<number>(0);
  const [pagination, setPagination] = useState<Pagination>(INITIAL_PAGINATION);

  useEffect(() => {
    getFunctionality(pagination)
      .then((res) => {
        setFunctionality(res.data.data);
        // setTotal(res.data.total);
      })
      .catch((error) => {
        console.log('Erro ao consultar funcionalidades', error);
      })
      .finally(() => {
        setRequest(false);
      });
  }, [request, pagination]);

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPagination({ ...pagination, page: newPage + 1 });
  };

  const registerFunctionality = async (functionality: Functionality) => {
    try {
      await (functionality.id ? putFunctionality(functionality) : postFunctionality(functionality));
      setSnackbar({
        msg: `Funcionalidade foi ${functionality.id ? 'atualizada' : 'cadastrada'} com sucesso!`,
        type: 'success',
      });
      addModal(false);
      setRequest(true);
    } catch (error) {
      console.log('Erro ao submeter funcionalidade!', error);
      setSnackbar({
        msg: `Erro ao ${functionality.id ? 'atualizar' : 'cadastrar'} funcionalidade!`,
        type: 'error',
      });
    }
  };

  const handleClickAction = (action: Action, functionality: Functionality) => {
    if (action === ACTION_EDIT_SUBMIT) {
      return registerFunctionality(functionality);
    }
    if (action === ACTION_DELETE) {
      return addModal(functionality.id);
    }
    if (action === ACTION_VIEW) {
      return history.push(`/seguranca/funcionalidade/${functionality.id}`);
    }
  };

  const handleClickDelete = async () => {
    await deleteFunctionality(Number(open))
      .then((res) => {
        setSnackbar({ msg: 'Funcionalidade excluída com sucesso!', type: 'success' });
        setRequest(true);
      })
      .catch((error) => {
        console.log('Erro ao excluir funcionalidade!', error);
        setSnackbar({ msg: 'Erro ao excluir funcionalidade!', type: 'error' });
      })
      .finally(function () {
        addModal(undefined);
      });
  };

  return (
    <>
      <GridComponent justify='space-between'>
        <Title>Funcionalidade</Title>

        <Modal
          title='Criar Funcionalidade'
          open={open === true}
          handleClick={() => addModal(!open)}
        >
          <Form initialValues={{ nome: '' }} handleSubmitForm={registerFunctionality}>
            <ButtonFormFull disabled={request} onClick={() => addModal(false)} />
          </Form>
        </Modal>
      </GridComponent>
      <ModalDelete
        open={!!open && open !== true}
        handleClick={() => addModal(undefined)}
        onClickSubmit={handleClickDelete}
        title='Confirma a exclusão dessa Funcionalidade?'
      />
      <br />
      <br />
      <Table
        request={request}
        data={functionality}
        // size={total}
        headCells={[
          { id: 'nome', label: 'Nome da Funcionalidade' },
          { id: ACTION, label: 'Ação' },
        ]}
        // rowsPerPage={30}
        // page={pagination.page}
        onChangePage={handleChangePage}
        editable
        handleClickAction={handleClickAction}
      />
    </>
  );
}
